export const routes ={  
HOME:'/',
ABOUTUS :'/about-us', 
CONTACTUS :'/contact-us',
FAQ:'/faqs', 
BLOGS:'/blogs', 
BLOGDESCRIPTION:'/blog-description',
CMSDEVELOPMENT:'/cms-development',
CROSSPLATFORMMOBILEAPPS:'/cross-platform-mobile-application-development',
CROSSPLATFORMMOBILEAPPDEVELOPMENT:'/cross-platform-app-development',
MOBILEAPPLICATIONDEVELOPMENT:'/mobile-app-development',
NATIVEAPPLICATIONS:'/native-applications',
WEBAPPS:'/web-applications',
IOTAPPLICATIONS:'/IoT-application-development',
DIGITALMARKETING:'/digital-marketing',
AIINTEGRATIONSANDCHATBOTS:'/ai-integrations-and-chatbots',
GRAPHICANDUIUXDESIGNING:'/graphic-and-ui-ux-designing',
PRIVACYPOLICY:'/privacy-policy',
TERMSANDCONDITIONS:'/terms-of-service',
BLOG1:'/welcome-to-our-new-site',
BLOG2:'/websites-for-small-businesses',
WEBSITEBRIEFFORM:'/brief-forms/website',
WEBSITEBRIEFFORMLOGODESIGN:'/brief-forms/logo-design',
SEARCHENGINEOPTIMIZATION:'/search-engine-optimization',
IOTDEVELOPMENTSERVICE:'/IoT-development',
NATIVEAPPDEVELOPMENT:'/native-app-development',
THANKSPAGE:'/contact-form-submission',
WEBAPPDEVELOPMENT:'/web-app-development'


}  